import {
  LAMBDATEST_DELETE_LOADING,
  LAMBDATEST_DELETE_SUCCESS,
  LAMBDATEST_DELETE_FAILED,
  LAMBDATEST_DELETE_CLEAR
} from "./../actionTypeConstants/LambdaTestDeleteConstants";

const initialState = {
  testDeleteState: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_DELETE_LOADING:
      return {
        ...state,
        testDeleteState: {
          ...state.testDeleteState,
          loading: true,
          data: null,
          error: null
        }
      };
    case LAMBDATEST_DELETE_SUCCESS:
      return {
        ...state,
        testDeleteState: {
          ...state.testDeleteState,
          loading: false,
          data: action.result.data,
          error: null
        }
      };
    case LAMBDATEST_DELETE_FAILED:
      return {
        ...state,
        testDeleteState: {
          ...state.testDeleteState,
          loading: false,
          error: action.error.response,
          data: null
        }
      };
    case LAMBDATEST_DELETE_CLEAR:
      return {
        ...state,
        testDeleteState: {
          loading: false,
          data: null,
          error: null
        }
      };
    default:
      return state;
  }
}
